export default __webpack_public_path__ + "static/media/jamaica_icon.82aaae88.png";